type TriStateCheckboxModel = {
  changeHandler: (event: any) => void;
  id: string;
  toggleState?: ListOptionState;
};

export enum ListOptionState {
  none = 'none',
  some = 'some',
  all = 'all',
}

export const TriStateCheckbox = ({ id, toggleState, changeHandler }: TriStateCheckboxModel) => {
  const checkboxId = `cc-stack-check-${id}`;

  return (
    <>
      <input type="checkbox" class={`hide-by-default ${checkboxId}`} id={checkboxId} />
      <label for={checkboxId}>
        <div
          onClick={changeHandler}
          id={`checkbox-stack-${id}`}
          class={`cc-accordion-header-checkbox cc-accordion-header-checkbox-state-${toggleState?.toString()}`}
        ></div>
      </label>
    </>
  );
};
